/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/formatting';

const PromoVoucher = ({ tenderInfo }) => {
  const {
    locale: { storeCurrency, storeLocale }, RL_PromotionName
  } = useSelector((state) => state);

  return (
    <>
      {tenderInfo.Tender?.Amount?.Amount && (
        <article className="justify-between">
          <p>{tenderInfo.Tender?.SubTenderType}</p>
          <p>{currencyFormatter(storeLocale, storeCurrency, tenderInfo.Tender?.Amount?.Amount)}</p>
        </article>
      )}
      {tenderInfo.Tender?.PromotionName && (
        <article className="justify-between">
          <p className="pl2-sm">{RL_PromotionName}: {tenderInfo.Tender.PromotionName}</p>
        </article>
      )}
      <br /> <br />
    </>
  );
};

PromoVoucher.defaultProps = {
  tenderInfo: {}
};

PromoVoucher.propTypes = {
  tenderInfo: PropTypes.shape()
};

export default PromoVoucher;
